export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">关于黑料视频</h2>
        <div className="text-sm md:text-base text-foreground-700 leading-relaxed space-y-4 max-w-2xl mx-auto">
          <p>
            黑料视频是国内领先的娱乐资讯视频聚合平台，致力于为用户提供<strong>黑料视频在线观看</strong>与<strong>黑料视频下载</strong>一站式服务。我们聚合全网最热门的黑料视频资源，涵盖娱乐圈、网红圈、综艺圈、音乐圈等多个领域，每日更新超过200条新鲜内容。
          </p>
          <p>
            平台自上线以来，凭借海量优质的独家内容和流畅的观看体验，迅速积累了超过500万活跃用户。我们始终坚持内容真实、更新及时的原则，为用户提供最新<strong>官网地址</strong>入口和<strong>手机app下载</strong>方式，确保每一位用户都能便捷地获取所需内容。
          </p>
          <p>
            无论你是资深吃瓜群众还是偶尔关注娱乐动态的普通用户，黑料视频都能满足你对热门话题内容的需求。我们的团队将持续优化平台体验，让黑料视频在线观看更加流畅，黑料视频下载更加便捷。
          </p>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-8 pt-8 border-t border-background-200/60">
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-bold text-primary-500">500万+</p>
            <p className="text-sm text-foreground-600 mt-1">活跃用户</p>
          </div>
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-bold text-accent-500">10万+</p>
            <p className="text-sm text-foreground-600 mt-1">视频资源</p>
          </div>
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-bold text-primary-500">200+</p>
            <p className="text-sm text-foreground-600 mt-1">每日更新</p>
          </div>
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-bold text-accent-500">99.9%</p>
            <p className="text-sm text-foreground-600 mt-1">可用率</p>
          </div>
        </div>
      </div>
    </section>
  );
}